function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
var VECTOR_LAYER_PREFIX = 'TimeSeriesMetadata_';
var DEFAULT_STYLE = {
  stroke: {
    width: 1,
    color: 'rgba(0, 0, 0, 0.8)'
  },
  fill: {
    color: null
  }
};
export var TimeseriesMetadataService = /*#__PURE__*/function () {
  function TimeseriesMetadataService(layerId, attributeName, toggleLevel, visualize) {
    _classCallCheck(this, TimeseriesMetadataService);
    this._layerId = layerId;
    this._attributeName = attributeName;
    this._visualize = visualize;
    if (typeof toggleLevel === 'number' && toggleLevel > -1) {
      this._toggleLevel = toggleLevel;
    } else {
      this._toggleLevel = -1;
    }
    this._geojson = null;
  }
  return _createClass(TimeseriesMetadataService, [{
    key: "getToggleLevel",
    value: function getToggleLevel() {
      return this._toggleLevel;
    }

    /**
     * Triggers a fetch for WFS features on the metadata layer
     * @param {Object} bbox usually the current viewport bbox
     * @param {Function} success called with updated years array based on the loaded features
     * @param {Function} error called if there's a problem loading the features
     */
  }, {
    key: "setBbox",
    value: function setBbox(bbox, success, error) {
      var _this = this;
      var sandbox = Oskari.getSandbox();
      if (!bbox || Object.keys(bbox).length !== 4) {
        this.clearPreviousFeatures();
        error('Invalid bbox');
        return;
      }
      // shrink query bbox to remedy the situations that the images are outside the
      // map view but the bounding box is inside the map view
      var shrinkRatio = 0.8;
      var bboxWidth = (bbox.right - bbox.left) * shrinkRatio;
      var bboxHeight = (bbox.top - bbox.bottom) * shrinkRatio;
      var bboxCenterX = (bbox.left + bbox.right) / 2;
      var bboxCenterY = (bbox.bottom + bbox.top) / 2;
      var left = bboxCenterX - bboxWidth / 2;
      var right = bboxCenterX + bboxWidth / 2;
      var bottom = bboxCenterY - bboxHeight / 2;
      var top = bboxCenterY + bboxHeight / 2;
      var bboxStr = [left, bottom, right, top].join(',');
      var attribute = this._attributeName;
      var url = Oskari.urls.getRoute('GetWFSFeatures', {
        id: this._layerId,
        bbox: bboxStr,
        srs: sandbox.getMap().getSrsName()
      });
      fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      }).then(function (response) {
        if (!response.ok) {
          // TODO: add error handling
          return Promise.reject(new Error('GetWFSFeatures error'));
        }
        return response.json();
      }).then(function (json) {
        _this._geojson = json;
        _this._updateYears(attribute);
        success(_this.getCurrentYears());
      }).catch(function (e) {
        error(e);
      });
    }
  }, {
    key: "_updateYears",
    value: function _updateYears(attribute) {
      var yearSet = new Set();
      this.getCurrentFeatures().forEach(function (feature) {
        var time = feature.properties[attribute];
        if (typeof time === 'number' && time < 10000) {
          // handle as year value
          yearSet.add(time);
        } else if (time) {
          var year = dayjs(time).year();
          yearSet.add(year);
        }
      });
      this._currentYears = Array.from(yearSet).sort();
    }
  }, {
    key: "getCurrentYears",
    value: function getCurrentYears() {
      return this._currentYears || [];
    }
  }, {
    key: "getCurrentFeatures",
    value: function getCurrentFeatures(asGeoJson) {
      var geoJson = this._geojson;
      if (!geoJson || !Array.isArray(geoJson.features)) {
        geoJson = {
          features: []
        };
      }
      return asGeoJson ? _objectSpread({}, geoJson) : _toConsumableArray(geoJson.features);
    }
  }, {
    key: "clearPreviousFeatures",
    value: function clearPreviousFeatures() {
      var sandbox = Oskari.getSandbox();
      // clear previous features from map
      sandbox.postRequestByName('MapModulePlugin.RemoveFeaturesFromMapRequest', [null, null, VECTOR_LAYER_PREFIX + this._layerId]);
    }
  }, {
    key: "showFeaturesForRange",
    value: function showFeaturesForRange(startTime, endTime) {
      if (!this._visualize) {
        // configured by admin to not show the features on map
        return;
      }
      var sandbox = Oskari.getSandbox();
      this.clearPreviousFeatures();
      var log = Oskari.log('TimeSeries');
      log.debug('Toggle at: ' + this._toggleLevel, 'Current zoom is: ' + sandbox.getMap().getZoom());
      if (this._toggleLevel === -1 || this._toggleLevel >= sandbox.getMap().getZoom()) {
        // don't show features but the wms
        log.debug('Not showing features, WMS should be shown');
        return;
      }
      var attribute = this._attributeName;
      var geojson = this.getCurrentFeatures(true);
      var features = geojson.features.filter(function (feature) {
        var time = dayjs(feature.properties[attribute]);
        return startTime < time && time < endTime;
      });
      log.debug('Features count for time range: ' + features.length + '/' + geojson.features.length);
      geojson.features = features;

      // TODO: push to map with addfeaturestomap/ styling/optimizing
      sandbox.postRequestByName('MapModulePlugin.AddFeaturesToMapRequest', [geojson, {
        layerId: VECTOR_LAYER_PREFIX + this._layerId,
        featureStyle: this._getWFSLayerStyle(this._layerId)
      }]);
    }
  }, {
    key: "_getWFSLayerStyle",
    value: function _getWFSLayerStyle(layerId) {
      var sandbox = Oskari.getSandbox();
      var service = sandbox.getService('Oskari.mapframework.service.MapLayerService');
      var layer = service.findMapLayer(layerId);
      if (!layer) {
        return DEFAULT_STYLE;
      }
      var styles = layer.getOptions().styles || {};
      var layerStyleDef = styles.timeseriesStyle || {};
      return layerStyleDef.featureStyle || DEFAULT_STYLE;
    }
  }]);
}();
;